import { render, staticRenderFns } from "./TicketsHistoryWrapper.vue?vue&type=template&id=6477c6be&scoped=true"
import script from "./TicketsHistoryWrapper.vue?vue&type=script&lang=js"
export * from "./TicketsHistoryWrapper.vue?vue&type=script&lang=js"
import style0 from "./TicketsHistoryWrapper.vue?vue&type=style&index=0&id=6477c6be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6477c6be",
  null
  
)

export default component.exports